var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".foo[data-v-9925819c]{width:100%;height:100%;background:url(" + escape(require("../assets/login_bg.jpg")) + ");position:fixed;background-repeat:no-repeat;background-position:0 0;background-size:100% 100%}.title[data-v-9925819c]{color:#fff}.fucko[data-v-9925819c]{margin-top:10px}#fucklogin[data-v-9925819c]{margin:15% auto;font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;color:#2c3e50;width:400px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9925819c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/xxxvue/Foo.vue
// module id = 122
// module chunks = 0